import * as React from "react";
import { Command as CommandPrimitive } from "cmdk";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";
import { Input } from "../../components/ui/input";
import { Skeleton } from "../../components/ui/skeleton";
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList, } from "../../components/ui/command";
import { Popover, PopoverAnchor, PopoverContent, } from "../../components/ui/popover";
function noDefault(e) {
    e.preventDefault();
}
export function AutoComplete({ id, readOnly, required, selectedValue, onSelectedValueChange, searchValue, onSearchValueChange, items, isLoading, emptyMessage = "No items.", placeholder = "Search...", }) {
    const [open, setOpen] = React.useState(false);
    const labels = React.useMemo(() => items.reduce((acc, item) => {
        acc[item.value] = item.label;
        return acc;
    }, {}), [items]);
    const reset = () => {
        onSelectedValueChange("");
        onSearchValueChange("");
    };
    const onInputBlur = (e) => {
        var _a;
        if (!((_a = e.relatedTarget) === null || _a === void 0 ? void 0 : _a.hasAttribute("cmdk-list")) &&
            labels[selectedValue] !== searchValue) {
            reset();
        }
    };
    const onSelectItem = (inputValue) => {
        var _a;
        if (inputValue === selectedValue) {
            reset();
        }
        else {
            onSelectedValueChange(inputValue);
            onSearchValueChange((_a = labels[inputValue]) !== null && _a !== void 0 ? _a : "");
        }
        setOpen(false);
    };
    return (React.createElement("div", { className: "flex items-center" },
        React.createElement(Popover, { open: open, onOpenChange: setOpen },
            React.createElement(Command, { shouldFilter: false },
                React.createElement(PopoverAnchor, { asChild: true },
                    React.createElement(CommandPrimitive.Input, { asChild: true, id: id, required: required, readOnly: readOnly, value: searchValue, onValueChange: onSearchValueChange, onKeyDown: (e) => setOpen(e.key !== "Escape"), onMouseDown: () => setOpen((open) => !!searchValue || !open), onFocus: () => setOpen(true), onBlur: onInputBlur },
                        React.createElement(Input, { placeholder: placeholder }))),
                !open && React.createElement(CommandList, { "aria-hidden": "true", className: "hidden" }),
                React.createElement(PopoverContent, { asChild: true, onOpenAutoFocus: noDefault, onInteractOutside: (e) => {
                        if (e.target instanceof Element &&
                            e.target.hasAttribute("cmdk-input")) {
                            noDefault(e);
                        }
                    }, className: "w-[--radix-popover-trigger-width] p-0" },
                    React.createElement(CommandList, null,
                        isLoading && (React.createElement(CommandPrimitive.Loading, null,
                            React.createElement("div", { className: "p-1" },
                                React.createElement(Skeleton, { className: "h-6 w-full" })))),
                        items.length > 0 && !isLoading ? (React.createElement(CommandGroup, null, items.map((option) => (React.createElement(CommandItem, { key: option.value, value: option.value, onMouseDown: noDefault, onSelect: onSelectItem },
                            React.createElement(Check, { className: cn("mr-2 h-4 w-4", selectedValue === option.value
                                    ? "opacity-100"
                                    : "opacity-0") }),
                            option.label))))) : null,
                        !isLoading ? (React.createElement(CommandEmpty, null, emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : "No items.")) : null))))));
}
//# sourceMappingURL=autocomplete.js.map